import './menuMobile.scss';
import $ from 'jquery';

$(function() {

/*    $('#mobile-menu').addClass('collapse');
    $('#mobileMenuTrigger').removeClass('d-none').addClass('d-block');*/

    //Animation
    $('.dropdown').on({
        "show.bs.dropdown" : function(e){ $(this).find('.dropdown-menu').first().stop(true, true).slideDown(300);},
        "hide.bs.dropdown" : function(e){ $(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);}
    });

    // ARIA + active class
    $('#mobileMenu .menu li .sub-menu').attr('aria-label','Sous-menu');
    $('#mobileMenu .menu li.current-menu-ancestor').addClass('active');
    $('#mobileMenu .menu li.current-menu-ancestor>a').addClass('active');
    $('#mobileMenu .menu li.current-menu-parent>a').addClass('active');
    $('#mobileMenu .menu .menu-item-has-children>a').attr('aria-haspopup','true');
    $('#mobileMenu .menu li.menu-item-has-children>a').click(function(e){
        e.preventDefault();
            $(this).next('ul').slideDown();
            if($(this).hasClass('active')){
                $(this).removeClass('active');
                $(this).parent().removeClass('active');
                $(this).next('ul').slideUp();
            } else {
                $(this).addClass('active');
                $(this).parent().addClass('active');
                $(this).next('ul').slideDown();
            }
            return false;
    })
});
